import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ELOutlineIcon: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path
				d="m13.229 3.3988a9.83 9.83 0 0 0-9.8302 9.8302 9.83 9.83 0 0 0 9.8302 9.8302 9.83 9.83 0 0 0 9.8302-9.8302 9.83 9.83 0 0 0-9.8302-9.8302zm0 1.3893a8.4408 8.4408 0 0 1 8.4409 8.4409 8.4408 8.4408 0 0 1-8.4409 8.4409 8.4408 8.4408 0 0 1-8.4409-8.4409 8.4408 8.4408 0 0 1 8.4409-8.4409z"
				fillRule="evenodd"
			/>
			<path
				d="m13.229 5.6675a7.5615 7.5615 0 0 0-7.5615 7.5615 7.5615 7.5615 0 0 0 7.5615 7.5615 7.5615 7.5615 0 0 0 7.5615-7.5615 7.5615 7.5615 0 0 0-7.5615-7.5615zm-0.59241 2.8488h1.1848c0.30915 0 0.55802 0.24887 0.55802 0.55802v0.67723c0 0.30915-0.24887 0.55802-0.55802 0.55802h-1.1848c-0.30915 0-0.55802-0.24887-0.55802-0.55802v-0.67723c0-0.30915 0.24887-0.55802 0.55802-0.55802zm0.01513 3.0597h1.1546c0.30363 0 0.54793 0.2443 0.54793 0.54793v5.4807c0 0.30363-0.2443 0.54793-0.54793 0.54793h-1.1546c-0.30363 0-0.54793-0.2443-0.54793-0.54793v-5.4807c0-0.30363 0.2443-0.54793 0.54793-0.54793z"
				fillRule="evenodd"
			/>
		</SvgIcon>
	);
};

export default ELOutlineIcon;



// WEBPACK FOOTER //
// ./src/icons/ELOutlineIcon.tsx